import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';
import { ValidationTypes } from '../validator-const.model';
import { CpqPopoverConfig } from '../../cpq-popover.model';

@Component({
    selector: 'show-errors',
    templateUrl: './show-error.component.html',
    styleUrls: ['./show-error.component.scss'],
    standalone: false
})
export class ShowErrorsComponent implements OnInit {
    @Input()
    private control: AbstractControlDirective | AbstractControl;
    @Input('errorHintPosition') errorHintPosition: 'left' | 'right' = 'right';
    public popoverConfig: CpqPopoverConfig;
    @ViewChild('htmlTemplate', {static: true}) htmlTemplate: TemplateRef<any>;

    ngOnInit() {
      this.popoverConfig = new CpqPopoverConfig({
        content: this.htmlTemplate,
        isError: true,
        placement: this.errorHintPosition
      });
    }

    shouldShowErrors(): boolean {
        return this.control &&
            this.control.errors &&
            (this.control.dirty || this.control.touched);
    }

    listOfErrors(): string[] {
        return Object.keys(this.control.errors)
            .map(field => this.getMessage(field, this.control.errors[field]));
    }

    // TODO translate error messages
    private getMessage(type: string, error: any) {
        if (error.message) {
            return error.message;
        } else {
            switch (type) {
                case 'required':
                    return 'Required';
                case 'maxlength':
                    return 'Too long';
                case 'minlength':
                    return 'Too short';
                case 'matDatepickerParse':
                    return 'Invalid date';
                case 'matDatepickerMin':
                case 'matDatepickerMax':
                    return 'Date is out of range';
                default:
                    return 'Validation Error';

            }
        }
    }
}
